"use strict";

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.KameleoonLogger = void 0;
var _types = require("./types"),
  _defaultLogger = require("./defaultLogger");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var replacer = function replacer(a, b) {
  return "credentials" === a ? {
    clientId: "****",
    clientSecret: "****"
  } : b instanceof Map ? Array.from(b.entries()) : b;
};
function template(a, b) {
  var c = "";
  if (b) for (var d, e = 0; e < b.length; e++) if (d = b[e], "object" == _typeof(d)) try {
    c += a[e] + JSON.stringify(d, replacer);
  } catch (b) {
    c += a[e] + "{object}";
  } else c += "string" == typeof d ? a[e] + "'" + d + "'" : a[e] + d;
  return c += a[a.length - 1], c;
}
var KameleoonLogger = /*#__PURE__*/function () {
  function KameleoonLogger() {
    _classCallCheck(this, KameleoonLogger);
  }
  return _createClass(KameleoonLogger, null, [{
    key: "setLogger",
    value: function setLogger(a) {
      KameleoonLogger.logger = a;
    }
  }, {
    key: "setLogLevel",
    value: function setLogLevel(a) {
      KameleoonLogger.logLevel = a;
    }
  }, {
    key: "log",
    value: function log(a) {
      var b = a.level,
        c = a.strings,
        d = a.keys;
      if (!KameleoonLogger.checkLevel(b)) return;
      var e;
      if ("string" == typeof c) e = c;else if ("function" == typeof c) try {
        e = c();
      } catch (a) {
        e = "Failed to log message";
      } else e = template(c, d);
      KameleoonLogger.writeMessage(b, e);
    }
  }, {
    key: "info",
    value: function info(a) {
      for (var b = arguments.length, c = Array(1 < b ? b - 1 : 0), d = 1; d < b; d++) c[d - 1] = arguments[d];
      KameleoonLogger.log({
        level: _types.LogLevel.INFO,
        strings: a,
        keys: c
      });
    }
  }, {
    key: "error",
    value: function error(a) {
      for (var b = arguments.length, c = Array(1 < b ? b - 1 : 0), d = 1; d < b; d++) c[d - 1] = arguments[d];
      KameleoonLogger.log({
        level: _types.LogLevel.ERROR,
        strings: a,
        keys: c
      });
    }
  }, {
    key: "warning",
    value: function warning(a) {
      for (var b = arguments.length, c = Array(1 < b ? b - 1 : 0), d = 1; d < b; d++) c[d - 1] = arguments[d];
      KameleoonLogger.log({
        level: _types.LogLevel.WARNING,
        strings: a,
        keys: c
      });
    }
  }, {
    key: "debug",
    value: function debug(a) {
      for (var b = arguments.length, c = Array(1 < b ? b - 1 : 0), d = 1; d < b; d++) c[d - 1] = arguments[d];
      KameleoonLogger.log({
        level: _types.LogLevel.DEBUG,
        strings: a,
        keys: c
      });
    }
  }, {
    key: "checkLevel",
    value: function checkLevel(a) {
      return a <= KameleoonLogger.logLevel && a !== _types.LogLevel.NONE;
    }
  }, {
    key: "writeMessage",
    value: function writeMessage(a, b) {
      KameleoonLogger.logger.log(a, "Kameleoon [".concat(_types.LOG_LEVEL_NAMES[a], "]: ").concat(b));
    }
  }]);
}();
exports.KameleoonLogger = KameleoonLogger, _defineProperty(KameleoonLogger, "logger", new _defaultLogger.DefaultLogger()), _defineProperty(KameleoonLogger, "logLevel", _types.LogLevel.WARNING);